import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useContext, useState } from 'react';

type ContextState = [boolean, Dispatch<SetStateAction<boolean>>];

const context = createContext<ContextState>([false, () => { throw new Error('Not implemented') }]);

export type ShowFormControlsProviderProps = {
    defaultState?: boolean;
}; 

export const useShowFormControls = () => {
    const ctx = useContext(context);
    
    if (!ctx) {
        throw new Error('useShowFormControls must be used within ShowFormControlsProvider');
    }

    return ctx;
}; 

export const ShowFormControlsProvider: FC<PropsWithChildren<ShowFormControlsProviderProps>> = ({children, defaultState = true}) => {
    const state = useState<boolean>(defaultState);
    
    return (
        <context.Provider value={state}>
            {children}
        </context.Provider>
    )
}; 
